import React from 'react'

function Founder({member}) {
  return (
    <figure className="founder">
        <img className="founder__img" src={member.url} />
        <div className={`founder--content ${member.id%2 == 0 && 'left'}`}>
            <h4 className='founder--content__title'>{member.name}</h4>
            <p className={`founder--content__description ${member.id%2 == 0 && 'left'}`}>{member.description}</p>
        </div>
    </figure>
  )
}

export default Founder